export default function About() {
  return (
    <section className="max-w-4xl mx-auto px-6 py-16 text-center">
      <h2 className="text-4xl font-bold text-blue-600 mb-6">Our Story</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        Popalooza was created to bring joy, fairness, and fun to mobile gaming.
      </p>
      <p className="text-lg text-gray-700 leading-relaxed">
        We believe games should be safe, inclusive, and delightful for kids and families everywhere.
      </p>
      <div className="mt-8">
        <img
          src="images/feature_banner.png"
          alt="Popalooza family-friendly gaming"
          className="rounded-lg shadow-lg mx-auto"
        />
      </div>
    </section>
  );
}
